import C1201Const from './C1201Const'

export default C1201Const.getStore()
